import React, {ReactNode} from 'react';
import cn from 'classnames';

import useBreakpoint from 'shared/lib/hooks/useBreakpoint';

import styles from './StatusBadge.module.scss';

interface IStatusBadgeProps {
    color: string,
    label: ReactNode,
    backgroundColor?: string | null,
    textOnly?: boolean,
    className?: string,
}

const StatusBadge: React.FC<IStatusBadgeProps> = ({
    color,
    label,
    backgroundColor = color,
    textOnly = false,
    className,
}) => {
    const currentBreakpoint = useBreakpoint();
    const isFilled = !textOnly && currentBreakpoint === 'large';
    const style = isFilled ? {backgroundColor: backgroundColor ?? undefined} : {color};

    return <div className={cn(styles.status, styles.badge, 'badge', className)} style={style}>{label}</div>;
};

export default StatusBadge;
